import { computed, defineComponent, reactive } from 'vue';
import moment from 'moment';
import VCalendarWrapper from '@hems/component/src/calendars/VCalendarWrapper.vue';
import { useModelWrapper } from '@hems/util';
export default defineComponent({
    name: 'VCalendar',
    components: {
        VCalendarWrapper,
    },
    inheritAttrs: false,
    props: {
        modelValue: {
            type: Date,
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
        format: {
            type: String,
            default: 'DD MMM, YYYY',
        },
        minDate: Date,
        maxDate: Date,
        validate: {
            type: Function,
            default: () => false,
        },
        mode: {
            type: String,
            default: 'date',
        },
    },
    setup(props, { emit }) {
        const state = reactive({
            open: false,
            value: useModelWrapper(props, emit),
            maxDate: new Date(),
        });
        const dateMode = computed(() => (props.mode ? props.mode : 'date'));
        const displayValue = computed(() => props.format
            ? moment(state.value).format(props.format)
            : moment(state.value).locale(navigator.language).format('LL'));
        const onOpen = () => (state.open = true);
        const onClose = () => (state.open = false);
        return {
            state,
            dateMode,
            displayValue,
            onOpen,
            onClose,
        };
    },
});
